"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navLink = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var navLink = {
  colors: {
    default: {
      colorDisabled: _colors.colors.gray,
      colorDisabledHoverFocus: _colors.colors.gray,
      colorTabsActive: _colors.colors.gray700,
      colorTabsActiveHoverFocus: _colors.colors.gray700,
      colorPillsActive: _colors.colors.white,
      colorPillsActiveHoverFocus: _colors.colors.white,
      color: _colors.colors.blue,
      colorHoverFocus: _colors.colors.blueHoverFocusA,
      backgroundColorPillsActive: _colors.colors.blue,
      borderColorTabsActive: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.white),
      borderColorTabsHoverFocus: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.gray300),
      borderColorTabsDisabled: 'transparent',
      borderColorPillsActive: _colors.colors.blue,
      borderColor: 'transparent'
    },
    light: {
      colorDisabled: _colors.colors.gray,
      colorDisabledHoverFocus: _colors.colors.gray,
      colorTabsActive: _colors.colors.gray700,
      colorTabsActiveHoverFocus: _colors.colors.gray700,
      colorPillsActive: _colors.colors.white,
      colorPillsActiveHoverFocus: _colors.colors.white,
      color: _colors.colors.blue,
      colorHoverFocus: _colors.colors.blueHoverFocusA,
      backgroundColorPillsActive: _colors.colors.blue,
      borderColorTabsActive: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.white),
      borderColorTabsHoverFocus: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.gray300),
      borderColorTabsDisabled: 'transparent',
      borderColorPillsActive: _colors.colors.blue,
      borderColor: 'transparent'
    },
    dark: {
      colorDisabled: _colors.colors.gray,
      colorDisabledHoverFocus: _colors.colors.gray,
      colorTabsActive: _colors.colors.gray700,
      colorTabsActiveHoverFocus: _colors.colors.gray700,
      colorPillsActive: _colors.colors.white,
      colorPillsActiveHoverFocus: _colors.colors.white,
      color: _colors.colors.blue,
      colorHoverFocus: _colors.colors.blueHoverFocusA,
      backgroundColorPillsActive: _colors.colors.blue,
      borderColorTabsActive: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.white),
      borderColorTabsHoverFocus: "".concat(_colors.colors.gray200, " ").concat(_colors.colors.gray200, " ").concat(_colors.colors.gray300),
      borderColorTabsDisabled: 'transparent',
      borderColorPillsActive: _colors.colors.blue,
      borderColor: 'transparent'
    }
  },
  padding: {
    default: '0.5rem'
  },
  borderRadius: _utils.utils.borderRadius,
  border: _utils.utils.border
};
exports.navLink = navLink;